import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Typography,
} from '@mui/material';

// 2026-06-17: Phase 3 Increment 3c — first-login onboarding for brand-new WorkOS accounts.
// Collects only what the inputs screen can't: birth date and (for married statuses) spouse birth
// date, plus filing status (which gates the spouse field and carries into the inputs screen).
// Required — no dismiss; the user completes it before reaching the inputs.
const FILING_OPTIONS = [
  { value: 'S', label: 'Single' },
  { value: 'M', label: 'Married filing jointly' },
  { value: 'H', label: 'Head of household' },
  { value: 'MS', label: 'Married filing separately (live together)' },
  { value: 'MD', label: 'Married filing separately (live apart)' },
];
const MARRIED = ['M', 'MS', 'MD'];

const WelcomeDialog = ({ open, onComplete, submitting }) => {
  const [birthDate, setBirthDate] = React.useState('');
  const [filingStatus, setFilingStatus] = React.useState('S');
  const [spouseBirthDate, setSpouseBirthDate] = React.useState('');
  const [error, setError] = React.useState(null);

  const isMarried = MARRIED.includes(filingStatus);

  const handleSubmit = () => {
    if (!birthDate) {
      setError('Please enter your birth date.');
      return;
    }
    if (isMarried && !spouseBirthDate) {
      setError("Please enter your spouse's birth date.");
      return;
    }
    setError(null);
    onComplete({
      birth_date: birthDate,
      distribution_status: filingStatus,
      birth_date_spouse: isMarried ? spouseBirthDate : null,
    });
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown>
      <DialogTitle>Welcome to RothGPT</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          A couple of basics so your analysis is accurate. You can change these anytime.
        </Typography>
        <TextField
          label="Your birth date"
          type="date"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
          fullWidth
          margin="normal"
          required
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          select
          label="Filing status"
          value={filingStatus}
          onChange={(e) => setFilingStatus(e.target.value)}
          fullWidth
          margin="normal"
        >
          {FILING_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </TextField>
        {isMarried && (
          <TextField
            label="Spouse birth date"
            type="date"
            value={spouseBirthDate}
            onChange={(e) => setSpouseBirthDate(e.target.value)}
            fullWidth
            margin="normal"
            required
            InputLabelProps={{ shrink: true }}
          />
        )}
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained" disabled={submitting}>
          {submitting ? 'Saving…' : 'Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
